import { render, staticRenderFns } from "./MandateStep1.vue?vue&type=template&id=437e4664&scoped=true&"
import script from "./MandateStep1.vue?vue&type=script&lang=js&"
export * from "./MandateStep1.vue?vue&type=script&lang=js&"
import style0 from "./MandateStep1.vue?vue&type=style&index=0&id=437e4664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e4664",
  null
  
)

export default component.exports